export default __webpack_public_path__ + "static/media/ceiling2.ee8daa60.jpeg";